export default "__VITE_ASSET__BKMrxURd__"